import React, {useState} from 'react';
import {TabPanel, TabView} from "primereact/tabview";

import './EapsmLicenseManager.scss'
import UsersTable from "./UsersTable";
import LicensesTable from "./LicensesTable";

function EapsmLicenseManager() {

    const [activeIndex, setActiveIndex] = useState<number>(0);

    return (
        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
            <TabPanel header="Users">
                <UsersTable />
            </TabPanel>
            <TabPanel header="Licenses">
                <LicensesTable />
            </TabPanel>
            <TabPanel header="License Assignation">
                License Assignation
            </TabPanel>
        </TabView>
    );
}

export default EapsmLicenseManager;